import * as types from './types';
import { success, error, loading } from 'State/actions';
//src\pages\pointofsale\modules\individualServing\state\actions.js
import { updateBalanceInProfile } from 'PointOfSale/modules/individualServing/state/actions';

export const getTransactionHistory = (
  pageNumber,
  pageSize,
  sortOptions,
  filterOptions,
  idSeed,
  primaryServingSite
) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.POS_GET_STUDENT_LOADING_TRANSACTIONHISTORY, true));
    try {
      const model = {
        PageNumber: pageNumber,
        PageSize: pageSize,
        SortColumn: sortOptions,
        Filter: filterOptions,
        IdSeed: idSeed,
        PrimarySiteId: primaryServingSite,
      };

      const response = await MPWWebApi.postGenericInsertUpdate(
        `student/transactionhistorywithpaging`,
        model
      );
      dispatch(
        success(types.POS_GET_STUDENT_TRANSACTIONHISTORY, response.data.Data)
      );
    } catch (err) {
      dispatch(error(types.POS_GET_STUDENT_TRANSACTIONHISTORY_ERROR, err));
    } finally {
      dispatch(
        loading(types.POS_GET_STUDENT_LOADING_TRANSACTIONHISTORY, false)
      );
    }
  };
};

export const postVoidTransaction = (transactionId) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.POS_GET_STUDENT_LOADING_TRANSACTIONHISTORY, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Serving/VoidTransaction`,
        {
          transactionId,
        }
      );

      dispatch(updateBalanceInProfile(response.data.Data.Balance));

      dispatch(
        success(types.POS_GET_STUDENT_TRANSACTIONHISTORY_SET_VOID_SUCCESS, true)
      );
    } catch (err) {
      dispatch(error(types.POS_GET_STUDENT_TRANSACTIONHISTORY_ERROR, err));
    } finally {
      dispatch(
        loading(types.POS_GET_STUDENT_LOADING_TRANSACTIONHISTORY, false)
      );
    }
  };
};

export const clearVoidSuccess = () => {
  return {
    type: types.POS_GET_STUDENT_TRANSACTIONHISTORY_SET_VOID_SUCCESS,
    payload: false,
  };
};

export const clearError = () => {
  return {
    type: types.POS_GET_STUDENT_TRANSACTIONHISTORY_CLEAR_ERROR,
    payload: null,
  };
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/history/state/action.js